import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  IconButton,
  InputAdornment,
  Divider,
} from "@mui/material";
import { LockOpen, Visibility, VisibilityOff } from "@mui/icons-material";
import { AuthenticacionProveedor } from "../../APIS/apiProveedor";
import Image from "mui-image";
import Logo from "../Imagenes/Logo_morado__icono_y_texto_abajo.png";

export function Login({ handleLogin }) {
  /* ─────────── estados ─────────── */
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /* ─────────── redirección si ya está logueado ─────────── */
  useEffect(() => {
    const auth = localStorage.getItem("isAuthenticated");
    const position = localStorage.getItem("position");
    if (auth === "true") {
      navigate(position === "Conductor" ? "/Conductor" : "/PortalProveedor");
    }
  }, [navigate]);

  /* ─────────── helpers ─────────── */
  const toggleShowPwd = () => setShowPassword((prev) => !prev);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    if (!username || !password) {
      setErrorMessage("Por favor, complete ambos campos");
      return;
    }

    setLoading(true);
    try {
      const {
        isAuthenticated,
        counter,
        firstname,
        status,
        position,
      } = await AuthenticacionProveedor(username, password);

      if (isAuthenticated && status === "Autorizado") {
        handleLogin(true);
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("counter", counter);
        localStorage.setItem("firstname", firstname);
        localStorage.setItem("position", position);
        navigate(position === "Conductor" ? "/Conductor" : "/PortalProveedor");
      } else if (status === "Bloqueado") {
        setErrorMessage("Este usuario está bloqueado. Contacte al administrador.");
      } else {
        setErrorMessage("Credenciales inválidas");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Hubo un error al autenticar. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  /* ─────────── UI ─────────── */
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        bgcolor: "#f3f6f9",
      }}
    >
      <Box
        sx={{
          width: { xs: "95%", md: "50%" },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            p: { xs: 6, md: 5 },
          }}
        >
          {/* ─────── Logo ─────── */}
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              xs={6}
              md={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: { xs: 4, md: 0 },
              }}
            >
              <Image  width="80%" src={Logo} fit="contain" duration={600} />
            </Grid>

            {/* ─────── Formulario ─────── */}
            <Grid container item xs={6} md={6} rowSpacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5" align="center" sx={{ fontWeight: 600 }}>
                  ¡Bienvenido de nuevo!
                </Typography>
                <Typography variant="subtitle1" align="center">
                  Ingrese sus credenciales para continuar
                </Typography>
                <Divider sx={{ mt: 2 }} />
              </Grid>

              {errorMessage && (
                <Grid item xs={12}>
                  <Typography color="error" align="center">
                    {errorMessage}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Correo electrónico"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={loading}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Contraseña"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={toggleShowPwd} edge="end" disabled={loading}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  startIcon={
                    loading ? <CircularProgress size={20} sx={{ color: "darkgray" }} /> : <LockOpen />
                  }
                  variant="contained"
                  fullWidth
                  onClick={handleSubmit}
                  disabled={loading}
                  sx={{
                    bgcolor: "#13254f",
                    "&:hover": { bgcolor: "#0f1d3f" },
                    textTransform: "uppercase",
                  }}
                >
                  {loading ? "Ingresando" : "Ingresar"}
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ mt: 1 }}>
                <Typography variant="caption" display="block" align="center" color="text.secondary">
                  SISTEMA DE TRANSPORTE PROVEEDOR
                </Typography>
                <Typography variant="caption" display="block" align="center" color="text.secondary">
                  RHAPCORE
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ─────── Fin Formulario ─────── */}
        </Paper>
      </Box>
    </Box>
  );
}
